import { render, staticRenderFns } from "./richtext-content.vue?vue&type=template&id=89477d02&"
import script from "./richtext-content.vue?vue&type=script&lang=js&"
export * from "./richtext-content.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Kentico\\Launchpad.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('89477d02', component.options)
    } else {
      api.reload('89477d02', component.options)
    }
    module.hot.accept("./richtext-content.vue?vue&type=template&id=89477d02&", function () {
      api.rerender('89477d02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/custom/vue/components/layout/richtext-content.vue"
export default component.exports